export const logo = {
  default: 'logo--default',
  neutral: 'logo--neutral',
  mixed: 'logo--mixed',
  plus: 'logo--plus',
};
